import { render, staticRenderFns } from "./ReviewTypeFormModal.vue?vue&type=template&id=fd87a512"
import script from "./ReviewTypeFormModal.ts?vue&type=script&lang=ts&external"
export * from "./ReviewTypeFormModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd87a512')) {
      api.createRecord('fd87a512', component.options)
    } else {
      api.reload('fd87a512', component.options)
    }
    module.hot.accept("./ReviewTypeFormModal.vue?vue&type=template&id=fd87a512", function () {
      api.rerender('fd87a512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/ReviewTypeFormModal.vue"
export default component.exports